/** Strips fractional seconds and Z suffix from API calendar instants for local parsing. */
export function stripCalendarInstant(iso: string): string {
  return iso.replace(/\.\d{3}Z?$/, '').replace(/Z$/, '');
}
